export class CatalogoCobro {

    public id:number;
    public codigoConsorcio:string;
    public conceptoCobro:string;
    public tipoUnidadCobro:string;
    public descripcionCobro:string;
    public costoEstandar:number;
    public codigoMoneda:string;

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/catalogo-cobro.ts